module.exports = "/images/loan-officer.png?42547b88c953aebaf6705be4e02d6214";